import { useEffect, useState } from "react";

const getMediaQuery = (query: string) => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null;
  }

  return window.matchMedia(query);
};

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => getMediaQuery(query)?.matches ?? false);

  useEffect(() => {
    const mediaQuery = getMediaQuery(query);

    if (!mediaQuery) {
      setMatches(false);
      return;
    }

    const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mediaQuery.matches);

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, [query]);

  return matches;
};
